module.exports = __webpack_public_path__ + "fonts/icons.b87b9ba5.b87b9ba5.ttf";